import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { UnsavedChangesService } from './unsaved-changes.service';
import { HasUnsavedChanges } from './unsaved-changes.types';

/**
 * Route guard that asks the user to confirm before navigating away from a
 * page with unsaved changes. The component must implement
 * `HasUnsavedChanges`; otherwise the guard is a no-op.
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
    if (!component || typeof component.hasUnsavedChanges !== 'function') {
        return true;
    }
    if (!component.hasUnsavedChanges()) {
        return true;
    }
    return inject(UnsavedChangesService).confirmDiscard(component);
};
